export interface FollowInputApiModel {
    resource_type: string;
    resource_id: number;
}

export class FollowUserInputApiModel {
    constructor() {
    }
}